import React, { useState, useRef, useEffect, lazy, Suspense } from 'react';
import normalizeWheel from 'normalize-wheel';
import { observer } from 'mobx-react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
// icons
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
const TrackInfoDialog = lazy(() => import('./dialogs/TrackInfoDialog'));
const useStyles = makeStyles()({
    button: {
        padding: 0,
    },
});
export const TrackLabel = observer(function ({ model, track, }) {
    const [anchorEl, setAnchorEl] = useState();
    const [trackInfoDialogOpen, setTrackInfoDialogOpen] = useState(false);
    const { rowHeight, treeAreaWidth: width } = model;
    const { height, model: { name }, } = track;
    const { classes } = useStyles();
    const trackLabelHeight = Math.max(8, rowHeight - 8);
    return (React.createElement("div", { style: {
            width,
            height,
            flexShrink: 0,
            textAlign: 'right',
            fontSize: trackLabelHeight,
        } },
        name,
        ' ',
        React.createElement(IconButton, { className: classes.button, style: {
                width: trackLabelHeight,
                height: trackLabelHeight,
            }, onClick: event => setAnchorEl(event.currentTarget) },
            React.createElement(ArrowDropDownIcon, null)),
        anchorEl ? (React.createElement(Menu, { anchorEl: anchorEl, transitionDuration: 0, open: true, onClose: () => setAnchorEl(undefined) },
            React.createElement(MenuItem, { dense: true, onClick: () => {
                    model.toggleTrack(track.model.id);
                    setAnchorEl(undefined);
                } }, "Close"),
            React.createElement(MenuItem, { dense: true, onClick: () => {
                    setTrackInfoDialogOpen(true);
                    setAnchorEl(undefined);
                } }, "Get info"))) : null,
        trackInfoDialogOpen ? (React.createElement(Suspense, { fallback: null },
            React.createElement(TrackInfoDialog, { model: track.model, onClose: () => setTrackInfoDialogOpen(false) }))) : null));
});
const Track = observer(function ({ model, track, }) {
    const { resizeHandleWidth } = model;
    const { model: { height, error }, } = track;
    const ref = useRef(null);
    const scheduled = useRef(false);
    const deltaX = useRef(0);
    useEffect(() => {
        const curr = ref.current;
        if (!curr) {
            return;
        }
        function onWheel(origEvent) {
            const event = normalizeWheel(origEvent);
            deltaX.current += event.pixelX;
            if (!scheduled.current) {
                scheduled.current = true;
                requestAnimationFrame(() => {
                    model.doScrollX(-deltaX.current);
                    deltaX.current = 0;
                    scheduled.current = false;
                });
            }
            origEvent.preventDefault();
        }
        curr.addEventListener('wheel', onWheel);
        return () => {
            curr.removeEventListener('wheel', onWheel);
        };
    }, [model]);
    return (React.createElement("div", { key: track.id, style: { display: 'flex', height } },
        React.createElement(TrackLabel, { model: model, track: track }),
        React.createElement("div", { style: { width: resizeHandleWidth, flexShrink: 0 } }),
        React.createElement("div", { ref: ref }, error ? (React.createElement("div", { style: { color: 'red', fontSize: 10 } }, `${error}`)) : (React.createElement(track.ReactComponent, { model: model, track: track })))));
});
export default Track;
//# sourceMappingURL=Track.js.map